export const supportEmail = "";

export const GA_TRACKING_CODE = "UA-158794622-1";
